import React, { useContext } from "react";
import YouTube from "react-youtube";
import { MediaContext } from "../../context/MediaContext";

const YouTubePlayer = ({ videoId }) => {
  const { setPlayer } = useContext(MediaContext);

  const opts = {
    playerVars: {
      autoplay: 0,
    },
  };

  const onReady = (e) => {
    var player = e.target;
    setPlayer(player);
  };

  return <YouTube videoId={videoId} opts={opts} onReady={onReady} />;
};

export default YouTubePlayer;
